export default __webpack_public_path__ + "static/media/TokioMarine.52c0f2ff.png";